import React from 'react';
import PropTypes from 'prop-types';
import FilterDefaultsModal from './filterdefaultsmodal/FilterDefaultsModal';
import Cog from '../../../common/Icons/Cog.svg';
import styles from './FilterDefaultsControl.module.scss';
import filterDefinitionsPropType from '../filterDefinitionsPropType';

const FilterDefaultsControl = ({ styles, ...props }) => (
    <div className={ styles.filterAmendsWrapper }>
        <div className={ styles.filterAmendDefaults }>
            <button
                type="button"
                className={ styles.button }
                onClick={ () => (props.isOpen ? props.closeControl() : props.openControl()) }
            >
                { props.showDefaultFilterMenu
                    && <img src={ Cog } alt="" className={ styles.svg } /> }
            </button>
        </div>
        <FilterDefaultsModal
            defaultFilters={ props.defaultFilters }
            filterDefinitions={ props.filterDefinitions }
            isOpen={ props.isOpen }
            closeControl={ props.closeControl }
            openDefaultFilter={ props.openDefaultFilter }
            closeDefaultFilter={ props.closeDefaultFilter }
            addDefaultFilter={ props.addDefaultFilter }
            removeDefaultFilter={ props.removeDefaultFilter }
            updateDefaultFilter={ props.updateDefaultFilter }
            currentlyOpenDefaultFilter={ props.currentlyOpenDefaultFilter }
            getAvailableListValues={ props.getAvailableListValues }
        />
    </div>
);

FilterDefaultsControl.propTypes = {
    defaultFilters: PropTypes.arrayOf(PropTypes.shape({})),
    filterDefinitions: filterDefinitionsPropType.isRequired,
    isOpen: PropTypes.bool,
    openControl: PropTypes.func.isRequired,
    closeControl: PropTypes.func.isRequired,
    openDefaultFilter: PropTypes.func.isRequired,
    closeDefaultFilter: PropTypes.func.isRequired,
    addDefaultFilter: PropTypes.func.isRequired,
    removeDefaultFilter: PropTypes.func.isRequired,
    updateDefaultFilter: PropTypes.func.isRequired,
    currentlyOpenDefaultFilter: PropTypes.string,
    getAvailableListValues: PropTypes.func.isRequired,
    showDefaultFilterMenu: PropTypes.bool,
    styles: PropTypes.objectOf(PropTypes.string)
};

FilterDefaultsControl.defaultProps = {
    defaultFilters: [],
    isOpen: false,
    currentlyOpenDefaultFilter: null,
    showDefaultFilterMenu: true,
    styles
};

export default FilterDefaultsControl;
